export enum ButtonType {
    PREV_NEXT = 1,
    PRIMARY = 2,
    PRIMARY_LIGHT = 3,
    SECONDARY = 4,
    // TERTIARY = 5,
    SUCCESS = 6,
    SUCCESS_LIGHT = 7,
    DELETE = 8,
    WARNING = 9,
    WHITE = 10,
    DELETE_LIGHT = 11,
    CANCEL = 12,
    CANCEL_LIGHT = 13,
    PRIMARY_NO_BG = 14,
}

// type BtnColorTypes = { [K in ButtonType]: { type: K, background: string, textColor: string } };